export default 'speedy';
